import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const BillingAdvanceUse = ({advanceData, fetchMembersData, isLoading, id}) => {
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [advanceInfo, setAdvanceInfo] = useState([]);

    const handleDelete = (key) => {
        const newData = [...advanceInfo];
        newData.splice(key, 1); 
        setAdvanceInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...advanceInfo];
        newData.push({
            advuse_ors: '',
            advuse_dates: undefined,
            advuse_amounts: '',
            advuse_remarks: '',
            isWritable: true,
        });
        setAdvanceInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setAdvanceInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setAdvanceInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = advanceInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setAdvanceInfo(newData);
    };

    const defaultColumns = [
        {
            title: 'OR',
            dataIndex: 'advuse_ors',
            align: 'center',
            key: 'advuse_ors',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.advuse_ors}
                    onChange={(e) => handleTable(e, index, "advuse_ors")}
                />
            ) : record.advuse_ors
          ),
        },
        {
            title: 'Date',
            dataIndex: 'advuse_dates',
            align: 'center',
            key: 'advuse_dates',
            render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.advuse_dates}
                    onChange={(e) => handleTable(e, index, "advuse_dates", true)}
                />
            ) : record.advuse_dates?.format('MMMM D, YYYY')
          ),
        },
        {
            title: 'Amount',
            dataIndex: 'advuse_amounts',
            align: 'center',
            key: 'advuse_amounts',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.advuse_amounts}
                    onChange={(e) => handleTable(e, index, "advuse_amounts")}
                />
            ) : record.advuse_amounts
          ),
        },
        {
            title: 'Remark',
            dataIndex: 'advuse_remarks',
            align: 'center',
            key: 'advuse_remarks',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.advuse_remarks}
                    onChange={(e) => handleTable(e, index, "advuse_remarks")}
                />
            ) : record.advuse_remarks
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];
    console.log(advanceInfo)

    const handleCreateAdvance = () => {
        try {
            const newValues = {
                member_id: id,
                id: [],
                advuse_ors: [],
                advuse_amounts: [],
                advuse_remarks: [],
                advuse_dates: [],
            }

            advanceInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.advuse_ors.push(item.advuse_ors || "");
                newValues.advuse_amounts.push(item.advuse_amounts || "");
                newValues.advuse_remarks.push(item.advuse_remarks || "");
                newValues.advuse_dates?.push(item.advuse_dates ? item.advuse_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_advance_use", 
                newValues,
                false,
            );
        } catch(errorInfo) {
            toast.error('Validation Failed ', errorInfo);
        };
    };

    const validateArray = (array) => {
        return array.every((item) => {
            return item.advuse_ors !== "" || item.advuse_dates !== undefined || item.advuse_amounts !== "" || item.advuse_remarks !== "";
        });
    };  

    useEffect(() => {
        if(advanceData){
            const admission_data = advanceData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                advuse_ors: data.or,
                advuse_dates: data.date ? dayjs(data.date) : undefined,
                advuse_amounts: data.amount,
                advuse_remarks: data.remark,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setAdvanceInfo(admission_data)
        }
    }, [advanceData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={advanceInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAdvance}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(advanceInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingAdvanceUse
